import { BasketLine, ReservationLineRequest } from '@models/api-orders.models';

export const mapToReservationLines = (items: BasketLine[]): ReservationLineRequest[] =>
    items.map(item => ({ quantity: item.quantity, variantNo: item.variantNo }));
